import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import { PageTitle } from "../utils/PageTitle";

export function Presskit() {
    const { t } = useTranslation();

    return (
        <Box>
            <Box position="relative" w="100%">
                <Image
                    src="/images/headings/heading-gamepad.jpg"
                    alt="heading-community"
                    w="100%"
                    h={{ base: 36, sm: 36, md: 56, lg: 72 }}
                    objectFit="cover"
                    objectPosition={"center center"}
                    shadow={"md"}
                />
                {/* original top={7} */}
                <Breadcrumb position="absolute" top={7} left={10} color={"white"}>
                    <BreadcrumbItem>
                        <BreadcrumbLink href="/">Garrigue Games</BreadcrumbLink>
                    </BreadcrumbItem>

                    <BreadcrumbItem fontWeight={"semibold"} isCurrentPage>
                        <BreadcrumbLink href="/presskit">Press Kit</BreadcrumbLink>
                    </BreadcrumbItem>
                </Breadcrumb>
            </Box>

            <VStack maxW={1536} p={10} alignItems={"left"}>
                <PageTitle>Press Kit</PageTitle>
                <Text marginBottom={5} fontSize="md">
                    {t("presskit.paragraph")}
                </Text>
                <HStack flexWrap={"wrap"}>
                    <Button as="a" href="/press-kit/gg-logo-assets.zip" download="gg-logo-assets.zip">
                        {t("presskit.logos")}
                    </Button>
                    <Button
                        as="a"
                        href="/press-kit/garrigue-games-guidelines.pdf"
                        download="garrigue-games-guidelines.pdf"
                    >
                        {t("presskit.guidelines")}
                    </Button>
                </HStack>
            </VStack>
        </Box>
    );
}

export default Presskit;
